import { render, staticRenderFns } from "./MobileFooterHome.vue?vue&type=template&id=2c98d3e7&scoped=true"
import script from "./MobileFooterHome.vue?vue&type=script&lang=js"
export * from "./MobileFooterHome.vue?vue&type=script&lang=js"
import style0 from "./MobileFooterHome.vue?vue&type=style&index=0&id=2c98d3e7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c98d3e7",
  null
  
)

export default component.exports